import moment from 'moment';
export default {
    methods: {
        formatServerDate(value) {
            return moment(value, 'YYYY-MM-DD HH:mm:SS').format('DD/MM/YYYY HH:mm');
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/formatServerDate.js